/**
 * RouteTracker - SPA Page View Tracking for GA4
 * 
 * Fixes the "SPA blindness" issue where GA4 doesn't track
 * route changes in React applications.
 * 
 * Features:
 * - Manual page_view events on route change
 * - URL normalization (lowercase, remove internal params)
 * - Deduplication (skips same-path navigations)
 */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { normalizeUrl } from '@/lib/analytics';
import { captureUtmParams } from '@/lib/utm';


function normalizePath(path: string): string {
  // Remove trailing slash, force lowercase
  return path.replace(/\/$/, '').toLowerCase() || '/';
}

export function RouteTracker() {
  const location = useLocation();
  const prevPathRef = useRef<string | null>(null);
  
  useEffect(() => {
    // Persist campaign params from the landing URL for the rest of the visit
    captureUtmParams();

    const currentPath = normalizePath(location.pathname);
    

    
    // Skip if same path (prevents duplicate fires on query param changes)
    if (prevPathRef.current === currentPath) {
      return;
    }
    
    prevPathRef.current = currentPath;
    
    // Fire manual page_view
    const normalizedUrl = normalizeUrl(window.location.href);
    
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'page_view', {
        page_title: document.title,
        page_location: normalizedUrl,
        page_path: currentPath,
      });
    }
    
    console.log(`[GA4] 📄 Page View: ${currentPath}`);
  }, [location.pathname]);
  
  return null; // No UI rendering
}
